import React from "react";
import {
  FiFacebook,
  FiInstagram,
  FiTwitter,
  FiMail,
  FiPhone,
  FiMapPin,
  FiMessageSquare,
} from "react-icons/fi";

const ContactInfo = () => {
  const socialLinks = [
    {
      icon: <FiFacebook />,
      label: "Facebook",
      href: "https://www.facebook.com/reflectionfutbolacademy",
    },
    {
      icon: <FiInstagram />,
      label: "Instagram",
      href: "https://www.instagram.com/reflectionfutbol.academy",
    },
    { icon: <FiTwitter />, label: "Twitter", href: "#" },
    {
      icon: <FiMessageSquare />,
      label: "WhatsApp",
      href: "https://wa.me/14055889793",
    },
  ];

  return (
    <div className="space-y-12">
      <div className="space-y-8">
        <h2 className="text-3xl font-inter font-extrabold text-[#222222] uppercase tracking-tight">
          Get in <span className="text-[#7D192A]">Touch</span>
        </h2>

        <div className="space-y-6">
          <div className="flex gap-6 group">
            <div className="w-14 h-14 !bg-[#F5F5F5] rounded-lg flex items-center justify-center text-[#7D192A] group-hover:!bg-[#7D192A] group-hover:!text-white transition-all duration-300">
              <FiMapPin size={28} />
            </div>
            <div>
              <h3 className="font-inter font-bold text-[#222222] uppercase tracking-wider">
                Our Location
              </h3>
              <p className="body-text text-gray-600">
                8201 SW 44th St, Oklahoma City, OK 73179
              </p>
            </div>
          </div>

          <div className="flex gap-6 group">
            <div className="w-14 h-14 !bg-[#F5F5F5] rounded-lg flex items-center justify-center text-[#7D192A] group-hover:!bg-[#7D192A] group-hover:!text-white transition-all duration-300">
              <FiPhone size={28} />
            </div>
            <div>
              <h3 className="font-inter font-bold text-[#222222] uppercase tracking-wider">
                Phone Number
              </h3>
              <p className="body-text text-gray-600">+1(405)-588-9793</p>
            </div>
          </div>

          <div className="flex gap-6 group">
            <div className="w-14 h-14 !bg-[#F5F5F5] rounded-lg flex items-center justify-center text-[#7D192A] group-hover:!bg-[#7D192A] group-hover:!text-white transition-all duration-300">
              <FiMail size={28} />
            </div>
            <div>
              <h3 className="font-inter font-bold text-[#222222] uppercase tracking-wider">
                Email Address
              </h3>
              <p className="body-text text-gray-600 break-all">
                Reflectionfutbolacademy@gmail.com
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-6">
        <h3 className="font-inter font-bold text-[#222222] uppercase tracking-wider">
          Follow Our Progress
        </h3>
        <div className="flex gap-4">
          {socialLinks.map((social, i) => (
            <a
              key={i}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-[#ffffff] border border-gray-200 rounded-xl flex items-center justify-center text-[#222222] hover:bg-[#7D192A] hover:text-white transition-all duration-300 shadow-soft"
              aria-label={social.label}
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>

      <a
        href="https://www.google.com/maps/search/?api=1&query=8201+SW+44th+St,+Oklahoma+City,+OK+73179"
        target="_blank"
        rel="noopener noreferrer"
        className="w-full h-80 bg-gray-100 rounded-2xl overflow-hidden shadow-soft border border-gray-200 flex items-center justify-center relative group cursor-pointer"
      >
        <img
          src="https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
          alt="Location of Reflection Futbol Academy in Oklahoma City"
          className="absolute inset-0 w-full h-full object-cover opacity-50 grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
        />
        <div className="relative z-10 bg-white/90 backdrop-blur px-6 py-4 rounded-full shadow-lg border border-[#F4B400]/20 group-hover:bg-[#7D192A] transition-colors duration-300">
          <span className="font-inter font-bold text-[#7D192A] group-hover:text-white flex items-center gap-2 transition-colors duration-300">
            <FiMapPin size={20} /> VIEW ON GOOGLE MAPS
          </span>
        </div>
      </a>
    </div>
  );
};

export default ContactInfo;
